import { useAuth } from '@/app/providers/AuthProvider';
import { LoadingScreen } from '@/components/LoadingScreen';
import { hasPlatformPermission } from '@/services/authService';
import type { ReactNode } from 'react';

interface RequireAnyPermissionProps {
  permissions: string[];
  fallback?: ReactNode;
  children: ReactNode;
}

export default function RequireAnyPermission({ permissions, fallback, children }: RequireAnyPermissionProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  // [1A.18.1-quater] Bypass isAdmin rimosso: hasPlatformPermission gestisce
  // Super Admin, wildcard e permesso esplicito.
  const hasAny = user && permissions.some((p) => hasPlatformPermission(user, p));

  if (!hasAny) {
    if (fallback) return <>{fallback}</>;
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center p-8 max-w-md">
          <h2 className="text-xl font-semibold text-zinc-900 dark:text-zinc-100 mb-2">
            Accesso negato
          </h2>
          <p className="text-zinc-600 dark:text-zinc-400">
            Non hai i permessi necessari per accedere a questa sezione.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
